import * as URL from "../helpers/Constants";
import axios from "axios";

export default class WithdrawService {


    static getWithdrawReport(params) {
        return axios({
            url: `${URL.GET_WITHDRAW_REPORT_EXCELL_URL}`,
            params,
            method: "GET",
            responseType: "blob", // Important,
            ...WithdrawService.getAuthHeaderForFileDownload(),
        });
    }

    static getAllWithdraw(params) {
        return axios.get(URL.GET_ALL_WITHDRAW_URL, {
            ...WithdrawService.getAuthHeader(),
            params
        });
    }

    static getWithdrawById(id) {
        return axios.get(`${URL.GET_WITHDRAW_BY_ID_uRL}/${id}`, WithdrawService.getAuthHeader());
    }

    static addWithdraw(data, pharmacyOwnerId) {

        return axios.post(URL.CREATE_WITHDRAW_URL, data, {
            ...WithdrawService.getAuthHeader(),
            params: {pharmacyOwnerId}
        });
    }

    static updateWithdraw(data, id) {
        return axios.put(`${URL.UPDATE_WITHDRAW_URL}/${id}`, data, WithdrawService.getAuthHeader());
    }


    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }

    static getAuthHeaderForFileDownload = () => {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Response-Type": "blob",
            },
        };
    };

}